import toast from 'react-hot-toast';

// Status Code to Message Mapping
const statusMessages = {
  200: 'Operation completed successfully',
  201: 'Created successfully',
  400: 'Invalid request. Please check your input.',
  401: 'Session expired. Please login again.',
  403: 'You do not have permission to perform this action.',
  404: 'Requested resource not found.',
  409: 'This data already exists.',
  422: 'Please check your input and try again.',
  500: 'Server error. Please try again later.',
};

// Toast Notification Helper
export const showToast = {
  success: (message: string) => {
    toast.success(message, {
      duration: 4000,
      position: 'top-right',
    });
  },
  error: (message: string) => {
    toast.error(message, {
      duration: 4000,
      position: 'top-right',
    });
  },
  warning: (message: string) => {
    toast(message, { 
      icon: '⚠️',
      duration: 4000,
      position: 'top-right',
    });
  },
  info: (message: string) => {
    toast(message, { 
      icon: 'ℹ️',
      duration: 4000,
      position: 'top-right',
    });
  },
};

// Handle API Response
export const handleApiResponse = (status: number, customMessage?: string) => {
  const message = customMessage || statusMessages[status as keyof typeof statusMessages] || 'Something went wrong';
  
  if (status >= 200 && status < 300) {
    showToast.success(message);
  } else if (status === 401) {
    showToast.error(message);
    // Force logout on 401
    localStorage.removeItem('token');
    window.location.href = '/login';
  } else {
    showToast.error(message);
  }
};

// Error Logging
export const logError = (error: any, apiName: string, userId?: string) => {
  const errorLog = {
    timestamp: new Date().toISOString(),
    userId: userId || 'anonymous',
    apiName,
    status: error.status || 'unknown',
    message: error.message || 'Unknown error',
    url: error.url || 'unknown',
  };
  
  console.error('API Error:', errorLog);
  
  // In production, send to logging service
  // logToService(errorLog);
};